import { gql } from "@apollo/client";

export default gql`
  fragment RaceDetails on Race {
    description
    distance
    isGreyhound
    numRunners
    surface {
      name
      shortName
      defaultCondition
    }
    type {
      name
      code
      shortName
    }
    changes {
      surface {
        distance {
          oldValue {
            value
            code
            name
            shortName
          }
          newValue {
            value
            code
            name
            shortName
          }
        }
        course {
          oldValue
          newValue
          date
        }
        condition {
          oldValue
          newValue
          date
        }
        tempRailDistance {
          oldValue
          newValue
          date
        }
      }
    }
    timeform {
      analystVerdict
    }
  }
`;
